import { PropagateLoader } from 'react-spinners';

const AcademiaLoading = () => {
  // rendering custom loading component here
  return (
    <div className='absolute top-0 left-0 h-full w-full flex items-center justify-center gap-2 z-50'>
      <PropagateLoader color='#35476F' />
    </div>
  );
};

export default AcademiaLoading;
